<template>
  <input v-maska="mask" @input="input" type="tel" :required="required" :id="id" :value="value" inputmode="tel"
         class="input-base block w-full sm:leading-5 rounded-md" :class="$parent.inputClass"
         :placeholder="placeholder"/>

</template>

<script>
import maska from "@/components/ui/form/maska/directive";
import {setup, mixin} from "@/components/ui/form/mixins/BaseInput";

export default {
  name: "UiFormTel",
  setup: setup,
  mixins: [mixin],
  directives: {maska},
  props: {
    mask: {
      default: '+7 (###) ###-##-##',
    }
  },
}
</script>
